import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import './BatchFilterEditor.scss';

const UNDEFINED_VALUE = 'UNDEFINED_VALUE';

const BatchFilterEditor = (props) => {
  const { value = UNDEFINED_VALUE, onValueChange, editor, className, style } = props;
  const selectValue = [UNDEFINED_VALUE, '-', '*'].indexOf(value) >= 0 ? value : '*';
  const idValue = selectValue === '*' && (value === '*' ? '' : value) || '';
  const handleChange = (event) => {
    let newValue = event.target.value;
    if (newValue === UNDEFINED_VALUE) {
      newValue = undefined;
    } else if (newValue === '*') {
      newValue = !idValue ? '*' : idValue;
    }
    onValueChange(newValue, editor);
  };
  const handleChangeId = (event) => {
    let newValue = event.target.value;
    if (!newValue || !newValue.length) {
      newValue = '*';
    }
    onValueChange(newValue, editor);
  };
  return (
    <div
      className={classnames('grb-batchfilter-editor', 'grb-enumfiltercell-editor', className)}
      style={style}
    >
      <FormControl>
        <InputLabel shrink htmlFor={editor.name}>{editor.title}</InputLabel>
        <Select
          value={selectValue}
          onChange={handleChange}
          inputProps={{
            name: `${editor.name}`,
            id: `${editor.name}`,
          }}
          input={<Input name={editor.name} />}
          displayEmpty
          name={editor.name}
        >
          {editor.namedValues.map(tr => <MenuItem value={tr.value === undefined ? UNDEFINED_VALUE : tr.value} key={tr.label}>{tr.label}</MenuItem>)}
        </Select>
      </FormControl>
      <FormControl className="grb-batchidfilter-editor">
        <InputLabel htmlFor={`input${editor.name}Id`}>Batch ID</InputLabel>
        <Input
          id={`input${editor.name}Id`}
          aria-describedby={`input${editor.name}Id helper text`}
          onChange={handleChangeId}
          value={idValue}
        />
      </FormControl>
    </div>
  );
};

BatchFilterEditor.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.shape({}),
  ]),
  editor: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    namedValues: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

BatchFilterEditor.defaultProps = {
  value: UNDEFINED_VALUE,
  className: undefined,
  style: {},
};

export default BatchFilterEditor;
